import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getExternalReferrals, getGroupInfoLeadre } from "../../api/group";
import { getGroupAreas, getGroupTrips } from "../../api/jahadgar";
import AddUserIcon from "../../assets/SVG/addUserIcon";
import EyeIcon from "../../assets/SVG/eyeIcon";
import PillIcon from "../../assets/SVG/pillIcon";
import NewUser from "../../components/leaderGroup/drug/newUser";
import CustomizedHook from "../../components/project/autocomplatePro";
import ErjaAdminPop from "./erjaAdminPop";
import TableErja from "./tableErja";

export default function Erja({ notGroup }) {
  const [open, setOpen] = useState();
  const [openAdmin, setOpenAdmin] = useState();
  const [dataUsers, setDataUsers] = useState();
  const [DataAreas2, setDataAreas2] = useState();
  const [areaId, setAreaId] = useState();
  const [dataGroup, setDataGroup] = useState();

  useEffect(() => {
    if (notGroup) {
      getGroupTrips()
        .then((x) => {
          setDataGroup(x);
          getGroupAreas()
            .then((x) => {
              setDataAreas2(x);
            })
            .catch(() => {});
        })
        .catch(() => {});
    } else {
      getGroupInfoLeadre()
        .then((x) => setDataGroup(x))
        .catch(() => {});
    }
  }, []);

  return (
    <>
      <Box>
        <NewUser erja open={open} setOpen={setOpen} />
        <ErjaAdminPop open={openAdmin} setOpen={setOpenAdmin} />
        <Typography mb="20px" className="title_GroupOnline">
          {"مسئول ارجاع"}
        </Typography>
        {!notGroup && (
          <Box mt="10px" display="flex" gap="10px">
            <Box
              display="flex"
              sx={{ cursor: "pointer" }}
              alignItems={"center"}
            >
              <AddUserIcon />
              <Typography
                fontWeight={"bold"}
                color="#4C8395"
                fontSize="16px"
                mr="10px"
                onClick={() => {
                  setOpen(!open);
                }}
              >
                اختصاص به کاربر
              </Typography>
            </Box>
            <Typography color="white" fontSize="20px">
              |
            </Typography>
            <Box
              display="flex"
              onClick={() => {
                setOpenAdmin(!openAdmin);
              }}
              sx={{ cursor: "pointer" }}
              alignItems={"center"}
            >
              <EyeIcon size="1.5" color="#4C8395" />
              <Typography
                fontWeight={"bold"}
                color="#4C8395"
                fontSize="16px"
                mr="10px"
              >
                مشاهده مسئول
              </Typography>
            </Box>
          </Box>
        )}
        <Box mt="20px"></Box>
        <Box display={"flex"} gap="30px">
          <Box sx={{ width: "20vw", overflow: "hidden" }}>
            <CustomizedHook
              multiple
              width={"20vw"}
              placeholder={"انتخاب کنید."}
              label="نام اردو"
              options={notGroup ? dataGroup : dataGroup?.activeTrips}
              onChange={(event, newValue) => {
                if (notGroup) {
                } else {
                  setDataAreas2(newValue.areas);
                }
              }}
              // value={
              //   countries.find((country) => country.name === stepOne.country) ||
              //   dataLoc?.countries ||
              //   null
              // }
            />
          </Box>
          <Box sx={{ width: "20vw", overflow: "hidden" }}>
            <CustomizedHook
              multiple
              width={"20vw"}
              placeholder={"انتخاب کنید."}
              label="نام منطقه"
              options={DataAreas2}
              onChange={(event, newValue) => {
                setAreaId(newValue.id);
              }}
              //   value={
              //     countries.find((country) => country.name === stepOne.country) ||
              //     dataLoc?.countries ||
              //     null
              //   }
            />
          </Box>
          <Button
            sx={{
              bgcolor: "#125383",
              color: "white",
              height: "37px",
              mt: "23px",
              width: "250px",
              borderRadius: "10px",
              //   px:"30px",
              ":hover": {
                bgcolor: "#0e3e61",
              },
            }}
            onClick={() => {
              if (areaId) {
                getExternalReferrals(areaId)
                  .then((x) => {
                    setDataUsers(x);
                  })
                  .catch(() => {});
              }
            }}
          >
            مشاهده بیماران ارجاع شده
          </Button>
        </Box>
        <Box height="50px" />
        {dataUsers && <TableErja areaId={areaId} rowData={dataUsers} />}
      </Box>
    </>
  );
}
